export class BaseEmployeeNotification {
    entityId?: number;
    additionalMessage: string;
}

export class BaseEmployeeNotificationByUser extends BaseEmployeeNotification {
    $type?: string = 'byUser';
    receiverUserId: number;
}

export class BaseEmployeeNotificationByUsers extends BaseEmployeeNotification {
    $type?: string = 'byUsers';
    receiverUserIds: number[];
}

export class BaseEmployeeNotificationByEmail extends BaseEmployeeNotification {
    $type?: string = 'byEmail';
    receiverEmail: string;
}

export class BaseEmployeeNotificationByEmails extends BaseEmployeeNotification {
    $type?: string = 'byEmails';
    receiverEmails: string[];
}
